import { c as _c } from "react/compiler-runtime";
import { useRollbar } from '@rollbar/react';
import { FileSourceEnum } from '@systemeio/file-manager';
import { DateTimePicker, FormInput, FormInputSearch, FormSelect, Hint, Popover, Tooltip, toast } from '@systemeio/ui';
import { BLOGS_API, createPost, deletePost, duplicatePost, updatePost } from 'modules/blogs/api/blog-api';
import BlogCategoriesCheckbox from 'modules/blogs/components/blog-categories-checkbox';
import { SchedulePostModal } from 'modules/blogs/components/schedule-post-modal';
import { useBlogPosts } from 'modules/blogs/hooks/use-blog-posts';
import { BlogEntityDuplicateInterface } from 'modules/blogs/types/blog-entity-interface';
import { BlogInterface } from 'modules/blogs/types/blog-interface';
import { BlogPostId, BlogPostsCreateInterface, BlogPostsEditInterface, BlogPostsErrorsInterface, BlogPostsFilterInterface, BlogPostsInterface } from 'modules/blogs/types/blog-posts-interface';
import { useEffect, useState } from 'react';
import { ImageUploaderWithPreviewImage } from 'shared/components/file-uploader/image-uploader-with-preview-image';
import FormUrlPathInput from 'shared/components/form-url-path-input';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { buildPath } from 'shared/utils/build-path';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { useBlogPostApi } from '../../hooks/use-blog-post-api';
import { ActivatePostModal } from '../activet-post-modal';
import BlogEntityDuplicateModal from '../blog-entity-duplicate-modal';
import { defaultErrors, defaultFilters, defaultValues } from './constants';
import { CheckCircleIcon, QuestionMarkIcon, TimeCircleIcon } from '@systemeio/ui/icons';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
interface BlogPostsProps {
  blog?: BlogInterface;
  blogId: string;
}
const BlogPosts = t0 => {
  const $ = _c(243);
  const {
    blog,
    blogId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const rollbar = useRollbar();
  const {
    user,
    intlLocale
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination(true);
  const [filter, setFilter] = useState(defaultFilters);
  const [errors, setErrors] = useState(defaultErrors);
  let t1;
  if ($[0] !== blogId || $[1] !== filter || $[2] !== limit || $[3] !== pagination) {
    t1 = {
      limit,
      pagination,
      id: blogId,
      filter
    };
    $[0] = blogId;
    $[1] = filter;
    $[2] = limit;
    $[3] = pagination;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    blogPosts,
    blogPostsMutate,
    blogPostsCounter
  } = useBlogPosts(t1);
  const {
    changePostStatus
  } = useBlogPostApi();
  const t2 = `${BLOGS_API}/${blogId}/posts`;
  let t3;
  if ($[5] !== setPagination || $[6] !== t2) {
    t3 = {
      api: t2,
      setPagination
    };
    $[5] = setPagination;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const updateData = useUpdateData(t3);
  let t4;
  if ($[8] !== t) {
    t4 = t("global.inactive");
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t4) {
    t5 = {
      id: "false",
      caption: t4
    };
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t) {
    t6 = t("global.active");
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = {
      caption: t6,
      id: "true"
    };
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t5 || $[17] !== t7) {
    t8 = [t5, t7];
    $[16] = t5;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const isActiveData = t8;
  let t9;
  if ($[19] !== blog || $[20] !== blogPosts || $[21] !== t || $[22] !== updateData) {
    t9 = async data => {
      ;
      try {
        await fetchWithErrors(async () => {
          if (blog) {
            const newData = {
              ...data,
              categories: data.categories?.map(_temp),
              image: data.image?.id || null
            };
            await createPost(blog?.id, newData);
            await updateData(true, blogPosts);
          }
        }, setErrors);
        toast.success(t("dashboard.blog.posts.created"));
      } catch (t10) {
        const e = t10;
        throw e;
      }
    };
    $[19] = blog;
    $[20] = blogPosts;
    $[21] = t;
    $[22] = updateData;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const onCreate = t9;
  let t10;
  if ($[24] !== blog || $[25] !== blogPosts || $[26] !== blogPostsMutate || $[27] !== updateData) {
    t10 = async (post, data_0) => {
      ;
      try {
        await fetchWithErrors(async () => {
          if (blog) {
            const newData_0 = {
              name: data_0.name,
              path: data_0.path,
              description: data_0.description,
              categories: data_0.categories.map(_temp2),
              image: data_0.image?.id || null,
              postedAt: data_0?.postedAt,
              activatedAt: data_0?.activatedAt
            };
            const response = await updatePost(post.id, newData_0);
            await updateData(false, undefined, {
              mutationData: blogPosts,
              onMutate: async () => {
                await blogPostsMutate(data_1 => {
                  if (data_1) {
                    return {
                      ...data_1,
                      items: data_1.items.map(el_1 => {
                        if (el_1.id === post.id) {
                          return {
                            ...response.data
                          };
                        } else {
                          return el_1;
                        }
                      })
                    };
                  }
                }, false);
              }
            });
          }
        }, setErrors);
      } catch (t11) {
        const e_0 = t11;
        throw e_0;
      }
    };
    $[24] = blog;
    $[25] = blogPosts;
    $[26] = blogPostsMutate;
    $[27] = updateData;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const onEdit = t10;
  let t11;
  if ($[29] !== blogPosts || $[30] !== rollbar) {
    t11 = () => {
      if (blogPosts) {
        blogPosts.items.map(blog_0 => {
          if (!blog_0.categories) {
            rollbar.info("Categories not found in  blog", {
              data: JSON.stringify(blog_0)
            });
          }
        });
      }
    };
    $[29] = blogPosts;
    $[30] = rollbar;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== blogPosts) {
    t12 = [blogPosts];
    $[32] = blogPosts;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  useEffect(t11, t12);
  let t13;
  if ($[34] !== blogPosts || $[35] !== updateData) {
    t13 = async blogPost => {
      ;
      try {
        await deletePost(blogPost.id);
        await updateData(false, blogPosts);
      } catch (t14) {
        const e_1 = t14;
        throw e_1;
      }
    };
    $[34] = blogPosts;
    $[35] = updateData;
    $[36] = t13;
  } else {
    t13 = $[36];
  }
  const onRemove = t13;
  let t14;
  if ($[37] !== blogPosts || $[38] !== updateData) {
    t14 = async (id, blogPost_0) => {
      await duplicatePost(id, blogPost_0);
      await updateData(false, blogPosts);
    };
    $[37] = blogPosts;
    $[38] = updateData;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  const duplicateHandler = t14;
  let t15;
  if ($[40] !== blogPosts || $[41] !== blogPostsMutate || $[42] !== updateData) {
    t15 = async (postId, post_0) => {
      await updateData(false, undefined, {
        mutationData: blogPosts,
        onMutate: async () => {
          await blogPostsMutate(data_2 => {
            if (data_2) {
              return {
                ...data_2,
                items: data_2.items.map(el_2 => {
                  if (el_2.id === postId) {
                    return post_0;
                  }
                  return el_2;
                })
              };
            }
          }, false);
        }
      });
    };
    $[40] = blogPosts;
    $[41] = blogPostsMutate;
    $[42] = updateData;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  const onSchedulePost = t15;
  let t16;
  if ($[44] !== blogPosts || $[45] !== blogPostsMutate || $[46] !== changePostStatus || $[47] !== updateData) {
    t16 = async blogPost_1 => {
      const update = blogPost_1.isActive ? "deactivate" : "activate";
      await changePostStatus(blogPost_1.id, update);
      await updateData(false, undefined, {
        mutationData: blogPosts,
        onMutate: async () => {
          await blogPostsMutate(data_3 => {
            if (data_3) {
              return {
                items: data_3.items.map(item => {
                  if (item.id === blogPost_1.id) {
                    item = {
                      ...item,
                      isActive: !item.isActive
                    };
                    if (!item.isActive) {
                      item.activatedAt = null;
                    }
                  }
                  return item;
                }),
                hasMore: data_3.hasMore
              };
            }
          }, false);
        }
      });
    };
    $[44] = blogPosts;
    $[45] = blogPostsMutate;
    $[46] = changePostStatus;
    $[47] = updateData;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  const onChangeStatus = t16;
  let t17;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setErrors(defaultErrors);
    $[49] = t17;
  } else {
    t17 = $[49];
  }
  const onModalClose = t17;
  let t18;
  if ($[50] !== t) {
    t18 = t("global.title_caption");
    $[50] = t;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  let t19;
  if ($[52] !== t18) {
    t19 = {
      key: "name",
      header: t18,
      widthPercent: 40,
      onRender: _temp3
    };
    $[52] = t18;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== t) {
    t20 = t("dashboard.blog.categories.title_plural");
    $[54] = t;
    $[55] = t20;
  } else {
    t20 = $[55];
  }
  let t21;
  if ($[56] !== t20) {
    t21 = {
      key: "category",
      header: t20,
      widthPercent: 20,
      onRender: _temp5
    };
    $[56] = t20;
    $[57] = t21;
  } else {
    t21 = $[57];
  }
  let t22;
  if ($[58] !== t) {
    t22 = t("global.status");
    $[58] = t;
    $[59] = t22;
  } else {
    t22 = $[59];
  }
  let t23;
  if ($[60] !== t || $[61] !== user?.dateFormat || $[62] !== user?.timeFormat || $[63] !== user?.timezone) {
    t23 = blogPost_4 => <div className="flex items-center lg:ml-4">{blogPost_4.activatedAt ? <>{blogPost_4.isActive ? <Tooltip label={blogPost_4.isActive ? t("global.active") : t("global.inactive")} mode="hover" key="status-tooltip"><CheckCircleIcon className="fill-green h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" /></Tooltip> : <Tooltip label={dateTimeFormat(blogPost_4.activatedAt, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })} mode="hover" key="status-tooltip"><TimeCircleIcon className="fill-yellow h-[16px] w-[16px] shrink-0 sm:h-[20px] sm:w-[20px]" /></Tooltip>}</> : <><Tooltip label={blogPost_4.isActive ? t("global.active") : t("global.inactive")} mode="hover" key="status-tooltip"><CheckCircleIcon className={`h-[16px] w-[16px] sm:h-[20px] sm:w-[20px] ${blogPost_4.isActive && "fill-green"}`} /></Tooltip></>}</div>;
    $[60] = t;
    $[61] = user?.dateFormat;
    $[62] = user?.timeFormat;
    $[63] = user?.timezone;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  let t24;
  if ($[65] !== t22 || $[66] !== t23) {
    t24 = {
      key: "isActive",
      header: t22,
      widthPercent: 15,
      onRender: t23
    };
    $[65] = t22;
    $[66] = t23;
    $[67] = t24;
  } else {
    t24 = $[67];
  }
  let t25;
  if ($[68] !== t) {
    t25 = t("global.created_on");
    $[68] = t;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  let t26;
  if ($[70] !== user?.dateFormat || $[71] !== user?.timeFormat || $[72] !== user?.timezone) {
    t26 = blogPost_5 => <span>{dateTimeFormat(blogPost_5.createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[70] = user?.dateFormat;
    $[71] = user?.timeFormat;
    $[72] = user?.timezone;
    $[73] = t26;
  } else {
    t26 = $[73];
  }
  let t27;
  if ($[74] !== t25 || $[75] !== t26) {
    t27 = {
      key: "createdAt",
      header: t25,
      widthPercent: 25,
      onRender: t26
    };
    $[74] = t25;
    $[75] = t26;
    $[76] = t27;
  } else {
    t27 = $[76];
  }
  let t28;
  if ($[77] !== t19 || $[78] !== t21 || $[79] !== t24 || $[80] !== t27) {
    t28 = [t19, t21, t24, t27];
    $[77] = t19;
    $[78] = t21;
    $[79] = t24;
    $[80] = t27;
    $[81] = t28;
  } else {
    t28 = $[81];
  }
  const columns = t28;
  let t29;
  if ($[82] !== t) {
    t29 = t("dashboard.blog.posts.title_plural");
    $[82] = t;
    $[83] = t29;
  } else {
    t29 = $[83];
  }
  let t30;
  if ($[84] !== limit || $[85] !== setLimit) {
    t30 = {
      limit,
      setLimit
    };
    $[84] = limit;
    $[85] = setLimit;
    $[86] = t30;
  } else {
    t30 = $[86];
  }
  let t31;
  if ($[87] !== pagination || $[88] !== setPagination) {
    t31 = {
      pagination,
      setPagination
    };
    $[87] = pagination;
    $[88] = setPagination;
    $[89] = t31;
  } else {
    t31 = $[89];
  }
  let t32;
  if ($[90] !== filter) {
    t32 = {
      filter,
      setFilter,
      defaultFilters
    };
    $[90] = filter;
    $[91] = t32;
  } else {
    t32 = $[91];
  }
  let t33;
  if ($[92] !== isActiveData || $[93] !== t) {
    t33 = {
      field: "isActive",
      onRender: (value, onChange) => <FormSelect key="status-filter" data={isActiveData} value={value} placeholder={t("dashboard.blog.posts.all_posts")} onChange={data_4 => onChange(data_4)} />
    };
    $[92] = isActiveData;
    $[93] = t;
    $[94] = t33;
  } else {
    t33 = $[94];
  }
  let t34;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = {
      field: "searchBy",
      onRender: _temp6
    };
    $[95] = t34;
  } else {
    t34 = $[95];
  }
  let t35;
  if ($[96] !== t33) {
    t35 = [t33, t34];
    $[96] = t33;
    $[97] = t35;
  } else {
    t35 = $[97];
  }
  let t36;
  if ($[98] !== t30 || $[99] !== t31 || $[100] !== t32 || $[101] !== t35) {
    t36 = {
      limiter: t30,
      paginator: t31,
      filterer: t32,
      filterable: t35
    };
    $[98] = t30;
    $[99] = t31;
    $[100] = t32;
    $[101] = t35;
    $[102] = t36;
  } else {
    t36 = $[102];
  }
  let t37;
  if ($[103] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = ["name", "description", "path"];
    $[103] = t37;
  } else {
    t37 = $[103];
  }
  let t38;
  if ($[104] !== t) {
    t38 = t("dashboard.blog.posts.create_new_blog_post");
    $[104] = t;
    $[105] = t38;
  } else {
    t38 = $[105];
  }
  let t39;
  if ($[106] !== errors || $[107] !== t) {
    t39 = {
      field: "name",
      onRender: (value_1, onChange_1, state, onChangeState) => <FormInput required={true} key="name-create" error={errors.name} value={value_1} label={<div className="flex items-center gap-1">{t("global.title_caption")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.posts.title_description")}>{_temp7}</Popover></div>} onChange={e_3 => {
        onChangeState({
          ...state,
          name: e_3.target.value,
          path: buildPath(e_3.target.value)
        });
      }} />
    };
    $[106] = errors;
    $[107] = t;
    $[108] = t39;
  } else {
    t39 = $[108];
  }
  let t40;
  if ($[109] !== errors || $[110] !== t) {
    t40 = {
      field: "description",
      onRender: (value_2, onChange_2) => <FormInput required={true} key="description-create" error={errors.description} value={value_2} label={<div className="flex items-center gap-1">{t("global.short_description")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.posts.short_description_description")}>{_temp8}</Popover></div>} onChange={e_4 => onChange_2(e_4.target.value)} />
    };
    $[109] = errors;
    $[110] = t;
    $[111] = t40;
  } else {
    t40 = $[111];
  }
  let t41;
  if ($[112] !== blog?.domain || $[113] !== blog?.path || $[114] !== errors || $[115] !== t) {
    t41 = {
      field: "path",
      onRender: (value_3, onChange_3) => <FormUrlPathInput required={true} key="path-create" value={value_3} error={errors.path} domainName={blog?.domain.domainName} additionalPath={blog?.path} label={<div className="flex items-center gap-1">{t("global.url_path")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.funnel.configuration.webinar.url_path_popover-2")}>{_temp9}</Popover></div>} onChange={e_5 => onChange_3(e_5.target.value)} />
    };
    $[112] = blog?.domain;
    $[113] = blog?.path;
    $[114] = errors;
    $[115] = t;
    $[116] = t41;
  } else {
    t41 = $[116];
  }
  let t42;
  if ($[117] !== errors || $[118] !== t) {
    t42 = {
      field: "image",
      onRender: (value_4, onChange_4) => <ImageUploaderWithPreviewImage key="image-create" value={value_4} label={<Hint label={t("dashboard.blog.posts.image_description")}>{t("global.image")}</Hint>} previewClassName="h-[300px] w-[300px]" error={errors.image} source={FileSourceEnum.BlogPost} aspectRatio={1.4285714285714286} onRemove={() => onChange_4(null)} onSelect={dataFile => onChange_4(dataFile)} />
    };
    $[117] = errors;
    $[118] = t;
    $[119] = t42;
  } else {
    t42 = $[119];
  }
  let t43;
  if ($[120] !== blogId || $[121] !== errors) {
    t43 = {
      field: "categories",
      onRender: (value_5, onChange_5) => <BlogCategoriesCheckbox blogId={blogId} key="categories-create" selectedCategories={value_5} onChange={data_5 => onChange_5(data_5)} error={errors.categories} />
    };
    $[120] = blogId;
    $[121] = errors;
    $[122] = t43;
  } else {
    t43 = $[122];
  }
  let t44;
  if ($[123] !== t39 || $[124] !== t40 || $[125] !== t41 || $[126] !== t42 || $[127] !== t43) {
    t44 = [t39, t40, t41, t42, t43];
    $[123] = t39;
    $[124] = t40;
    $[125] = t41;
    $[126] = t42;
    $[127] = t43;
    $[128] = t44;
  } else {
    t44 = $[128];
  }
  let t45;
  if ($[129] !== onCreate || $[130] !== t38 || $[131] !== t44) {
    t45 = {
      onCreate,
      onAfterLeave: onModalClose,
      requiredFields: t37,
      fullCaption: t38,
      needToast: false,
      defaultValues,
      creatable: t44
    };
    $[129] = onCreate;
    $[130] = t38;
    $[131] = t44;
    $[132] = t45;
  } else {
    t45 = $[132];
  }
  let t46;
  if ($[133] !== t) {
    t46 = t("dashboard.blog.posts.title");
    $[133] = t;
    $[134] = t46;
  } else {
    t46 = $[134];
  }
  let t47;
  if ($[135] !== blog?.domain || $[136] !== blog?.path) {
    t47 = {
      name: "view",
      openInNew: true,
      setHref: blogPost_6 => blogPost_6.isActive ? `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${blog?.domain.domainName}${blog?.path !== "" ? `/${blog?.path}` : ""}${blogPost_6.path !== "" ? `/${blogPost_6.path}` : ""}` : `/blog/post/${blogPost_6.id}/generate-preview`
    };
    $[135] = blog?.domain;
    $[136] = blog?.path;
    $[137] = t47;
  } else {
    t47 = $[137];
  }
  let t48;
  if ($[138] !== t) {
    t48 = t("dashboard.actions.title.edit");
    $[138] = t;
    $[139] = t48;
  } else {
    t48 = $[139];
  }
  let t49;
  if ($[140] !== t48) {
    t49 = {
      caption: t48,
      name: "edit",
      openInNew: false,
      setHref: _temp10
    };
    $[140] = t48;
    $[141] = t49;
  } else {
    t49 = $[141];
  }
  let t50;
  if ($[142] !== t47 || $[143] !== t49) {
    t50 = [t47, t49];
    $[142] = t47;
    $[143] = t49;
    $[144] = t50;
  } else {
    t50 = $[144];
  }
  let t51;
  if ($[145] !== t) {
    t51 = t("dashboard.actions.title.duplicate");
    $[145] = t;
    $[146] = t51;
  } else {
    t51 = $[146];
  }
  let t52;
  if ($[147] !== duplicateHandler || $[148] !== t) {
    t52 = (opened, onClose, post_1, key) => <BlogEntityDuplicateModal key={key} opened={opened} blogEntity={post_1} title={t("dashboard.blog.page.duplicate_blog_post")} onClose={onClose} onUpdateData={async () => {
      onModalClose();
      onClose();
    }} duplicateHandler={duplicateHandler} />;
    $[147] = duplicateHandler;
    $[148] = t;
    $[149] = t52;
  } else {
    t52 = $[149];
  }
  let t53;
  if ($[150] !== t51 || $[151] !== t52) {
    t53 = {
      name: "duplicate",
      caption: t51,
      onActionRender: t52
    };
    $[150] = t51;
    $[151] = t52;
    $[152] = t53;
  } else {
    t53 = $[152];
  }
  let t54;
  if ($[153] !== t) {
    t54 = t("dashboard.blog.posts.schedule");
    $[153] = t;
    $[154] = t54;
  } else {
    t54 = $[154];
  }
  let t55;
  if ($[155] !== onSchedulePost) {
    t55 = (opened_0, onClose_0, post_2, key_0) => <SchedulePostModal key={key_0} opened={opened_0} onClose={onClose_0} post={post_2} onSchedulePost={onSchedulePost} />;
    $[155] = onSchedulePost;
    $[156] = t55;
  } else {
    t55 = $[156];
  }
  let t56;
  if ($[157] !== t54 || $[158] !== t55) {
    t56 = {
      name: "Schedule",
      caption: t54,
      onActionRender: t55
    };
    $[157] = t54;
    $[158] = t55;
    $[159] = t56;
  } else {
    t56 = $[159];
  }
  let t57;
  if ($[160] !== t) {
    t57 = t("dashboard.actions.title.activate");
    $[160] = t;
    $[161] = t57;
  } else {
    t57 = $[161];
  }
  let t58;
  if ($[162] !== onChangeStatus || $[163] !== onSchedulePost) {
    t58 = (opened_1, onClose_1, post_3, key_1) => <ActivatePostModal key={key_1} opened={opened_1} onClose={onClose_1} post={post_3} onChangeStatus={onChangeStatus} onSchedulePost={onSchedulePost} />;
    $[162] = onChangeStatus;
    $[163] = onSchedulePost;
    $[164] = t58;
  } else {
    t58 = $[164];
  }
  let t59;
  if ($[165] !== t57 || $[166] !== t58) {
    t59 = {
      name: "isActive",
      caption: t57,
      shouldRender: _temp11,
      onActionRender: t58
    };
    $[165] = t57;
    $[166] = t58;
    $[167] = t59;
  } else {
    t59 = $[167];
  }
  let t60;
  if ($[168] !== t53 || $[169] !== t56 || $[170] !== t59) {
    t60 = [t53, t56, t59];
    $[168] = t53;
    $[169] = t56;
    $[170] = t59;
    $[171] = t60;
  } else {
    t60 = $[171];
  }
  let t61;
  if ($[172] !== t) {
    t61 = t("dashboard.blog.posts.updated");
    $[172] = t;
    $[173] = t61;
  } else {
    t61 = $[173];
  }
  let t62;
  if ($[174] !== t) {
    t62 = t("dashboard.blog.posts.edit_posts");
    $[174] = t;
    $[175] = t62;
  } else {
    t62 = $[175];
  }
  let t63;
  if ($[176] !== errors || $[177] !== t) {
    t63 = {
      field: "name",
      onRender: (value_6, onChange_6) => <FormInput required={true} key="name-edit" error={errors.name} value={value_6} label={<div className="flex items-center gap-1">{t("global.title_caption")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.posts.title_description")}>{_temp12}</Popover></div>} onChange={e_6 => onChange_6(e_6.target.value)} />
    };
    $[176] = errors;
    $[177] = t;
    $[178] = t63;
  } else {
    t63 = $[178];
  }
  let t64;
  if ($[179] !== errors || $[180] !== t) {
    t64 = {
      field: "description",
      onRender: (value_7, onChange_7) => <FormInput required={true} key="description-edit" error={errors.description} value={value_7} label={<div className="flex items-center gap-1">{t("global.short_description")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.posts.short_description_description")}>{_temp13}</Popover></div>} onChange={e_7 => onChange_7(e_7.target.value)} />
    };
    $[179] = errors;
    $[180] = t;
    $[181] = t64;
  } else {
    t64 = $[181];
  }
  let t65;
  if ($[182] !== blog?.domain || $[183] !== blog?.path || $[184] !== errors || $[185] !== t) {
    t65 = {
      field: "path",
      onRender: (value_8, onChange_8) => <FormUrlPathInput required={true} key="path-edit" value={value_8} error={errors.path} domainName={blog?.domain.domainName} additionalPath={blog?.path} label={<div className="flex items-center gap-1">{t("global.url_path")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.funnel.configuration.webinar.url_path_popover-2")}>{_temp14}</Popover></div>} onChange={e_8 => onChange_8(e_8.target.value)} />
    };
    $[182] = blog?.domain;
    $[183] = blog?.path;
    $[184] = errors;
    $[185] = t;
    $[186] = t65;
  } else {
    t65 = $[186];
  }
  let t66;
  if ($[187] !== errors || $[188] !== intlLocale || $[189] !== t || $[190] !== user?.createdAt || $[191] !== user?.dateFormat || $[192] !== user?.timeFormat || $[193] !== user?.timezone) {
    t66 = {
      field: "postedAt",
      onRender: (value_9, onChange_9) => <div key="postedAt" className="flex flex-col gap-1"><div className="flex items-center gap-1">{t("dashboard.blog.posts.post_publication_date.title")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.posts.post_publication_date.popover")}>{_temp15}</Popover></div><DateTimePicker error={errors.postedAt} value={value_9} onChange={value_10 => onChange_9(value_10)} createdAt={user?.createdAt} timezone={user?.timezone} userDateFormat={user?.dateFormat} userTimeFormat={user?.timeFormat} intlLocale={intlLocale} /></div>
    };
    $[187] = errors;
    $[188] = intlLocale;
    $[189] = t;
    $[190] = user?.createdAt;
    $[191] = user?.dateFormat;
    $[192] = user?.timeFormat;
    $[193] = user?.timezone;
    $[194] = t66;
  } else {
    t66 = $[194];
  }
  let t67;
  if ($[195] !== errors || $[196] !== t) {
    t67 = {
      field: "image",
      onRender: (value_11, onChange_10) => <ImageUploaderWithPreviewImage key="image-edit" value={value_11} label={<Hint label={t("dashboard.blog.posts.image_description")}>{t("global.image")}</Hint>} previewClassName="h-[300px] w-[300px]" error={errors.image} source={FileSourceEnum.BlogPost} aspectRatio={1.4285714285714286} onRemove={() => onChange_10(null)} onSelect={file => onChange_10(file)} />
    };
    $[195] = errors;
    $[196] = t;
    $[197] = t67;
  } else {
    t67 = $[197];
  }
  let t68;
  if ($[198] !== blogId || $[199] !== errors) {
    t68 = {
      field: "categories",
      onRender: (value_12, onChange_11) => <BlogCategoriesCheckbox blogId={blogId} key="categories-edit" selectedCategories={value_12} onChange={data_6 => onChange_11(data_6)} error={errors.categories} />
    };
    $[198] = blogId;
    $[199] = errors;
    $[200] = t68;
  } else {
    t68 = $[200];
  }
  let t69;
  if ($[201] !== t63 || $[202] !== t64 || $[203] !== t65 || $[204] !== t66 || $[205] !== t67 || $[206] !== t68) {
    t69 = [t63, t64, t65, t66, t67, t68];
    $[201] = t63;
    $[202] = t64;
    $[203] = t65;
    $[204] = t66;
    $[205] = t67;
    $[206] = t68;
    $[207] = t69;
  } else {
    t69 = $[207];
  }
  let t70;
  if ($[208] !== onEdit || $[209] !== t61 || $[210] !== t62 || $[211] !== t69) {
    t70 = {
      onEdit,
      toastCaption: t61,
      fullCaption: t62,
      onModalClose,
      editable: t69
    };
    $[208] = onEdit;
    $[209] = t61;
    $[210] = t62;
    $[211] = t69;
    $[212] = t70;
  } else {
    t70 = $[212];
  }
  let t71;
  if ($[213] !== onChangeStatus) {
    t71 = {
      customStatusField: "isActive",
      onChange: blogPost_9 => onChangeStatus(blogPost_9),
      shouldRender: _temp16
    };
    $[213] = onChangeStatus;
    $[214] = t71;
  } else {
    t71 = $[214];
  }
  let t72;
  if ($[215] !== onRemove) {
    t72 = {
      onChange: onRemove
    };
    $[215] = onRemove;
    $[216] = t72;
  } else {
    t72 = $[216];
  }
  let t73;
  if ($[217] !== t50 || $[218] !== t60 || $[219] !== t70 || $[220] !== t71 || $[221] !== t72) {
    t73 = {
      openLink: t50,
      custom: t60,
      settings: t70,
      activate: t71,
      remove: t72
    };
    $[217] = t50;
    $[218] = t60;
    $[219] = t70;
    $[220] = t71;
    $[221] = t72;
    $[222] = t73;
  } else {
    t73 = $[222];
  }
  let t74;
  if ($[223] !== pagination || $[224] !== setPagination) {
    t74 = {
      pagination,
      setPagination
    };
    $[223] = pagination;
    $[224] = setPagination;
    $[225] = t74;
  } else {
    t74 = $[225];
  }
  let t75;
  if ($[226] !== limit || $[227] !== setLimit) {
    t75 = {
      limit,
      setLimit
    };
    $[226] = limit;
    $[227] = setLimit;
    $[228] = t75;
  } else {
    t75 = $[228];
  }
  let t76;
  if ($[229] !== blogPosts || $[230] !== columns || $[231] !== t46 || $[232] !== t73 || $[233] !== t74 || $[234] !== t75) {
    t76 = <Table caption={t46} actions={t73} data={blogPosts} columns={columns} paginator={t74} limiter={t75} />;
    $[229] = blogPosts;
    $[230] = columns;
    $[231] = t46;
    $[232] = t73;
    $[233] = t74;
    $[234] = t75;
    $[235] = t76;
  } else {
    t76 = $[235];
  }
  let t77;
  if ($[236] !== blogPosts || $[237] !== blogPostsCounter || $[238] !== t29 || $[239] !== t36 || $[240] !== t45 || $[241] !== t76) {
    t77 = <ListingLayout title={t29} counter={blogPostsCounter} data={blogPosts} type="compact" filterData={t36} createData={t45}>{t76}</ListingLayout>;
    $[236] = blogPosts;
    $[237] = blogPostsCounter;
    $[238] = t29;
    $[239] = t36;
    $[240] = t45;
    $[241] = t76;
    $[242] = t77;
  } else {
    t77 = $[242];
  }
  return t77;
};
export default BlogPosts;
function _temp(el) {
  return el.id;
}
function _temp2(el_0) {
  return el_0.id;
}
function _temp3(blogPost_2) {
  return <div className="truncate"><a rel="noreferrer" className="primary-link w-full" href={getPageEditorUrl(blogPost_2.pageId)}>{blogPost_2.name}</a></div>;
}
function _temp4(el_3) {
  return <li className="truncate" key={el_3.id}>{el_3.name}</li>;
}
function _temp5(blogPost_3) {
  return <ul className="flex w-full flex-col gap-1.5">{blogPost_3.categories?.map(_temp4)}</ul>;
}
function _temp6(value_0, onChange_0) {
  return <FormInputSearch key="searchBy-filter" onClear={() => onChange_0("")} value={value_0} onChange={e_2 => onChange_0(e_2.target.value)} />;
}
function _temp7(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp8(show_0) {
  return <QuestionMarkIcon className={`${show_0 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp9(show_1) {
  return <QuestionMarkIcon className={`${show_1 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp10(blogPost_7) {
  return getPageEditorUrl(blogPost_7.pageId);
}
function _temp11(blogPost_8) {
  return blogPost_8.isActive === false;
}
function _temp12(show_2) {
  return <QuestionMarkIcon className={`${show_2 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp13(show_3) {
  return <QuestionMarkIcon className={`${show_3 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp14(show_4) {
  return <QuestionMarkIcon className={`${show_4 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp15(show_5) {
  return <QuestionMarkIcon className={`${show_5 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp16(blogPost_10) {
  return blogPost_10.isActive;
}